import {initWebComponent} from "@/helpers/web-component-helper";
import {addLayer, getLayerByName} from "@/helpers/ol/ol-layer-helper";
import {toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";

export class LayerInfoInfoItemGeometryMeasure extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');

        template.innerHTML = ``

        initWebComponent(this, template)
    }
}

